import type { SxProps, Theme } from '@mui/material'

export const cardSectionContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  py: { xs: 4, md: 6 },
  px: { xs: 2, md: 4 },
}

export const cardSectionTitleSx: SxProps<Theme> = {
  color: 'text.primary',
  fontSize: { xs: '1.5rem', md: '1.75rem' },
  fontWeight: 600,
  textAlign: 'center',
  mb: 1,
}

export const cardSectionSubtitleSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: { xs: '1rem', md: '1.1rem' },
  fontWeight: 400,
  textAlign: 'center',
  mb: { xs: 4, md: 6 },
}

export const cardSectionCardsContainerSx = (maxWidth: number): SxProps<Theme> => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: { xs: 4, md: 6 },
  width: '100%',
  maxWidth,
})

export const cardSx: SxProps<Theme> = (theme) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  flex: { xs: '1 1 100%', md: '1 1 0' },
  maxWidth: 420,
  px: { xs: 2.5, md: 4 },
  py: { xs: 3.5, md: 5 },
  borderRadius: 2,
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(62, 39, 35, 0.03)',
  border:
    theme.palette.mode === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.06)'
      : '1px solid rgba(62, 39, 35, 0.08)',
})

export const cardTitleSx: SxProps<Theme> = {
  color: 'text.primary',
  fontSize: { xs: '1.25rem', md: '1.5rem' },
  fontWeight: 600,
  mb: 0.5,
}

export const cardDescriptionSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '0.95rem',
  lineHeight: 1.6,
}

export const visuallyHiddenSx: SxProps<Theme> = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
  border: 0,
}
